// extracted by css-extract-rspack-plugin
module.exports =  {"container":"App__container___jATbr"};